import Vue from 'vue'
import Quill from 'quill'
import VueQuillEditor from 'vue-quill-editor'
import { ImageUpload } from 'quill-image-upload'

// require styles
import 'quill/dist/quill.snow.css'

Quill.register('modules/imageUpload', ImageUpload)

Vue.use(VueQuillEditor, {
  modules: {
    toolbar: [
      ['bold', 'italic', 'underline', 'strike', 'blockquote'],
      [{ 'list': 'ordered' }, { 'list': 'bullet' }],
      [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
      [{ 'align': [] }],
      ['link', 'image'],
      ['clean']
    ],
    imageUpload: {
      url: `${window.axios.defaults.baseURL}/media`,
      method: 'POST',
      headers: {
        Authorization: localStorage.getItem('token')
      },
      callbackOK: (serverResponse, next) => {
        next(serverResponse.data.images.original)
      },
      callbackKO: (serverError) => {
        console.log(serverError)
      },
      checkBeforeSend: (file, next) => {
        next(file)
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/bootstrap/quill.js